import Reflux from 'reflux'

import FiltersActions from '~/actions/filters.js'


export default class extends Reflux.Store {
	constructor() {
		super()

		this.listenables = FiltersActions

		this.state = {
			categoryID: 0,
			text: ''
		}
	}

	setCategory(inCategoryID) {
		this.setState({ categoryID: inCategoryID })
	}

	setText(inText) {
		this.setState({ text: inText })
	}

	reset() {
		this.setState({
			text: '',
			categoryID: 0
		})
	}
}



// WEBPACK FOOTER //
// ./src/stores/filters.js